<template>
  <Field>
    <Label>{{ label }}</Label>
    <div class="stk-checkboxes form-radios checklist-field">
      <label
        v-for="option in displayedOptions"
        class="stk-checkbox"
      >
        <input
          type="checkbox"
          :disabled="isReadonly"
          :checked="selectedValues.includes(option)"
          @change="onToggle(option, $event)"
        >
        {{ option }}
      </label>
    </div>
  </Field>
</template>

<script>
import {
  Field,
  Label,
} from '@stakeui';

export default {
  name: 'MultiSelectChecklistField',
  components: {
    Field,
    Label,
  },
  props: {
    label: {
      type: String,
      default: 'Options',
    },
    value: {
      type: [String, Array],
      default: '',
    },
    options: {
      type: Array,
      default: () => ([]),
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selectedValues() {
      if (Array.isArray(this.value)) {
        return this.value.map(item => String(item).trim()).filter(Boolean);
      }
      return String(this.value || '').split(';').map(item => item.trim()).filter(Boolean);
    },
    displayedOptions() {
      const missingSelectedValues = this.selectedValues.filter(value => !this.options.includes(value));
      return [...this.options, ...missingSelectedValues];
    },
  },
  methods: {
    onToggle(option, event) {
      if (this.isReadonly) {
        return;
      }
      const shouldSelect = Boolean(event?.target?.checked);
      let nextValues = this.selectedValues.filter(value => value !== option);
      if (shouldSelect) {
        nextValues = [...new Set([...this.selectedValues, option])];
      }
      this.$emit('input', nextValues.join(';'));
    },
  },
};
</script>

<style scoped>
.form-radios {
  display: grid;
  gap: var(--stk-size-2);
}

.checklist-field input[type='checkbox'] {
  accent-color: var(--stk-primary);
}
</style>
